/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import cx from 'clsx';
import { trackCreativeClick, useTrackCreativeView } from '@kcd/event-tracker';

type Props = {
  children: React.ReactNode;
  adGroupId: number;
  creativeId: number;
  name?: string;
  className?: string;
};

// /placement api를 요청할 떄 래핑하는 컴포넌트 -> 앰플리튜드 이벤트를 보내는데 사용함.
const PlacementRenderer = ({
  children,
  adGroupId,
  creativeId,
  name,
  className,
}: Props) => {
  const onCreativeClicked = React.useCallback(() => {
    trackCreativeClick({
      adGroupId,
      creativeId,
      placementName: name || '',
    });
  }, []);

  const ref = useTrackCreativeView({
    adGroupId,
    creativeId,
    placementName: name || '',
  });

  return (
    <div
      role="presentation"
      className={cx(className)}
      ref={ref}
      onClick={onCreativeClicked}
    >
      {children}
    </div>
  );
};

export default PlacementRenderer;
